<template>
  <div class="container-filho" v-if="campanhas">
    <div class="campanha-container" v-for="(campanha, index) in campanhas" :key="index">
      <template v-if="campanha.ativo">
        <div
          class="mdl-shadow--1dp mdl-card--campanha"
          :style="segmento.seg_campanhas.background"
        >
          <div class="mdl-card__media mdl-text mdl-grid center-items">
            <i class="material-icons icon-campanha">{{ campanha.icone }}</i>
          </div>
          <div class="mdl-card__supporting-text card-campanha-titulo text-left-items">
            <span class="span-campanha-titulo">{{ campanha.titulo }}</span>
          </div>
          <div class="mdl-card__supporting-text card-campanha-desc text-left-items">
            <span class="span-campanha-desc">{{ campanha.texto }}</span>
          </div>
        </div>
        <div class="div-campanha__div">
          <button
            class="div-campanha__btn mf__btn--voltar"
            :style="segmento.seg_campanhas.button.left.background"
            @click="removerCampanha(campanha)"
          >
            <span class="mf__m-auto">{{ campanha.texto_button_left }}</span>
            <i class="mf__m-auto-0 material-icons icon-button">close</i>
          </button>
          <button
            class="div-campanha__btn mf__btn--confirmar"
            :style="segmento.seg_campanhas.button.right.background"
            @click="contratarCampanha(campanha)"
          >
            <span class="mf__m-auto">{{ campanha.texto_button_right }}</span>
            <i class="mf__m-auto-0 material-icons icon-button">arrow_forward</i>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import FirebaseHelper from "@/service/FirebaseHelper";
import { mapGetters, mapActions } from "vuex";
const { nivelCampanha } = require("../enuns/Camapanha.enum");

class CampanhaPortal {
  constructor(campanha) {
    this.ativo = true;
    this.id = campanha.id;
    this.icone = campanha.comunicacao.icone;
    this.titulo = campanha.comunicacao.titulo;
    this.texto = campanha.comunicacao.texto;
    this.texto_button_left = campanha.comunicacao.texto_button_left;
    this.texto_button_right = campanha.comunicacao.texto_button_right;
    this.portal_link = campanha.link;
  }
}

export default {
  name: "CardCampanhas",
  data() {
    return {
      firebaseHelper: new FirebaseHelper(),
      campanhas: [],
      campanhasAtivas: [],
      get_campanhas: [],
      dataCampanhas: null
    };
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      campanhas_ativas: "campanhas_ativas",
      segmento: "segmento",
      isRP: "isRP",
      chave: "chave"
    }),
  },
  async created() {
    this.dataCampanhas = (this.participante.data || {}).campanhas
    if (Object.keys(this.campanhas_ativas).length === 0) {
      let get_campanhas = await this.firebaseHelper.getCampanhas();
      this.atualizarEstadoCampanhasAtivas(get_campanhas);
    }
    this.get_campanhas = this.campanhas_ativas;
    this.carregarCampanhasAtivas();
    this.verificarCampanhas();
    this.campanhaDataVizualizacao();
  },
  methods: {
    ...mapActions([
      "atualizarEstadoCampanhasAtivas",
      "atualizarEstadoParticipante"
    ]),
    campanhaDataVizualizacao() {
      if (!this.isRP) {
        if (Object.keys(this.campanhas_ativas).length > 0) {
          let campanhas = this.campanhas_ativas;
          campanhas.forEach((campanha) => {
            this.firebaseHelper.setDataNivelCampanha(
              campanha.id,
              this.chave,
              nivelCampanha.VISUALIZACAO
            );
          });
        }
      }
    },
    carregarCampanhasAtivas() {
      if (this.get_campanhas) {
        this.campanhasAtivas = [];
        for (var i = 0; i < this.get_campanhas.length; i++) {
          if (
            this.get_campanhas[i].comunicacao.isCard &&
            this.get_campanhas[i].comunicacao
          ) {
            let campanha = {
              id: this.get_campanhas[i].idCampanha,
              link: this.get_campanhas[i].configuracao.motivo.link,
              comunicacao: this.get_campanhas[i].comunicacao,
            };
            this.campanhasAtivas.push(campanha);
          }
        }
      }
    },
    verificarCampanhas() {
      if (this.dataCampanhas && this.campanhasAtivas && this.campanhasAtivas.length > 0) {
        this.campanhasAtivas.forEach((campanha) => {
          let existe = Object.entries(this.dataCampanhas).find(
            (camp) => Number(camp[0]) === Number(campanha.id)
          );
          if (existe && existe[1].ativo) {
            this.campanhas.push(new CampanhaPortal(campanha));
          }
        });
      }
    },
    removerCampanha(campanha) {
      this.firebaseHelper.removerCampanha(this.chave, campanha.id);
      campanha.ativo = false;
      this.atualizarcampanhas(campanha);
    },
    atualizarcampanhas(campanha) {      
      this.participante.data.campanhas[campanha.id] = { ativo: false };
      this.atualizarEstadoParticipante(this.participante)
    },
    contratarCampanha(campanha) {
      this.campanhaVisualizacao(campanha);
      this.removerCampanha(campanha);
      switch (campanha.portal_link) {
        case "cadastro":
          this.$router.push("/cadastro");
          break;
        case "simulador-emprestimo":
          this.$router.push("/emprestimo");
          break;
        case "simulador-renda":
          this.$router.push("/renda");
          break;
        case "simulador-seguro":
          this.$router.push("/seguro");
          break;
        case "simulador-aporte":
          this.$router.push("/simuladoraporte");
          break;
        default:
          if (campanha.portal_link.includes("http")) {
            window.open(campanha.portal_link, "_blank");
          } else {
            this.$router.push("/" + campanha.portal_link);
          }
          break;
      }
    },
    campanhaVisualizacao(campanha) {
      if (this.campanhas_ativas && !this.isRP) {
        let campanhas_ativas = this.campanhas_ativas;
        let campanha_ativa = campanhas_ativas.find((c) => {
          return c.id === campanha.id;
        });
        if (campanha_ativa) {
          return this.firebaseHelper.setDataNivelCampanha(
            campanha.id,
            this.chave,
            nivelCampanha.CLICK
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.campanha-container {
  margin: 25px 0px;
}
.div-campanha__div {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.div-campanha__btn {
  border-radius: 8px !important;
  width: 49%;
  margin: 0px;
  display: flex;
  justify-content: space-between;
  font-family: "MaisFuturo-Medium";
  letter-spacing: -0.19px;
  color: white;
  opacity: 1;
}
.mdl-card--campanha {
  flex-direction: column;
  border-radius: 8px !important;
  background: #1b4785;
  padding-left: 65px;
  min-height: 90px;
  display: flex;
  justify-content: space-evenly;
}
.icon-campanha {
  font-size: 40px;
  font-style: italic;
  color: white;
  opacity: 1;
}
.card-campanha-titulo {
  font-size: 14px;
  font-family: "MaisFuturo-Medium";
  letter-spacing: -0.19px;
  color: white;
  opacity: 1;
}
.span-campanha-titulo {
  padding: 5px 5px 0px 0px !important;
}
.card-campanha-desc {
  font-size: 13px;
  font-family: "MaisFuturo-Thin";
  letter-spacing: -0.21px;
  color: white;
  opacity: 1;
}
.span-campanha-desc {
  padding: 0px 5px 5px 0px !important;
}
.text-left-items {
  display: flex;
  align-items: center;
  justify-content: left;
}
.mdl-card--campanha .mdl-card__media {
  width: 65px;
  position: absolute;
  left: 10px;
  background-color: transparent;
}
.mdl-card--campanha .mdl-card__supporting-text {
  width: auto;
  background-color: transparent;
}
@media screen and (max-width: 360px) {
  .div-campanha__div {
    display: block;
  }
  .div-campanha__btn span {
    font-size: 11px;
  }
  .div-campanha__btn {
    width: 100%;
  }
}
@media screen and (min-width: 440px) {
  button.div-campanha__btn span {
    font-size: 12px;
  }
}
</style>
